import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import Dashboard from './Dashboard';
import Settings from './Settings';
import History from './History';
import Profile from './Profile';
import ScanBag from './ScanBag';
import Login from './Login';
import BottomNavbar from './BottomNavbar';
import Register from './Register';
import Bags from './Bags';
import OrderForm from './OrderForm';
import Collections from './Collections';
import Verified from './Verified';
import Mobile from './mobile';
import SubscriptionPayment from './SubscriptionPayment';
import CreateCollection from './CreateCollection';
import SubscriptionPage from './SubscriptionPage';
import {useUser} from "./UserContext";

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [token, setToken] = useState(null);
	const {user}=useUser();
    useEffect(() => {
        // Check if the token exists in localStorage on initial load
        const storedToken = localStorage.getItem('authToken');
        if (storedToken) {
            setToken(storedToken);
            setIsAuthenticated(true);
        }
    }, []);

    return (
        <>
            <Routes>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/history" element={<History />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/scan" element={<ScanBag />} />
                <Route path="/" element={<Login setToken={setToken} setIsAuthenticated={setIsAuthenticated} />} />
                <Route path="/login" element={<Login setToken={setToken} setIsAuthenticated={setIsAuthenticated} />} />
                <Route path="/register" element={<Register setToken={setToken} setIsAuthenticated={setIsAuthenticated} />} />
                <Route path="/bags" element={<Bags />} />
                <Route path="/order" element={<OrderForm />} />
                <Route path="/collections" element={<Collections />} />
                <Route path="/subscription" element={<SubscriptionPayment />} />
                <Route path="/create-collection" element={<CreateCollection />} />
                <Route path="/subscription-page" element={<SubscriptionPage />} />
            </Routes>
            {user && (
               
                    <Verified />
                
            )}
            <BottomNavbar />
        </>
    );
}

export default App;
